const s = {
  name: "Iceland",
  dimensions: { width: 24, height: 24 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M10.2,0L9,4.7V24h2V5l0.8-3h0.5L13,5v19h2V4.7L13.8,0H10.2z"/>
		<path class="st0" d="M8,9v15H6V9H8z"/>
		<path class="st0" d="M5,24v-9H3v9H5z"/>
		<path class="st0" d="M2,19v5H0v-5H2z"/>
		<path class="st0" d="M18,24h-2V9h2V24z"/>
		<path class="st0" d="M21,15v9h-2v-9H21z"/>
		<path class="st0" d="M24,24v-5h-2v5H24z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Iceland
};
